<template>
  <div>
    <v-layout row wrap>
      <v-flex 
        v-for="(sponsor,i) in sponsors"
        :key="`sponsor_${i}`"
        xs4
        sm2
        class="sponsor_container">
        <template v-if="sponsor.url">
          <a 
            :href="sponsor.url"
            target="_blanck">
            <img 
              :src="sponsor.image" 
              :alt="sponsor.name"
              class="sponsor_image" >
          </a>
        </template>
        <template v-else>
          <img 
            :src="sponsor.image" 
            :alt="sponsor.name"
            class="sponsor_image" >
        </template>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
// const debug = require('debug')('OD::Sponsors')

export default {
  name: 'Sponsors',
  components: {},
  props: {
    sponsors: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {}
  },
  computed: {},
  watch: {},
  created() {},
  methods: {},
}
</script>

<style lang="scss" scoped>
.sponsor_container {
  padding: 5px;
}
.sponsor_image {
  width: 100%;
}
</style>
